import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { IAvatarInfo } from 'shared/ui'
import { type IResponseAnalyticsSurveyContactCustom } from 'entities/Analytics/api/types'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'

export class SurveyContactRow extends RowBase<IResponseAnalyticsSurveyContactCustom> {
  constructor(origin: IResponseAnalyticsSurveyContactCustom) {
    super(origin)

    makeObservableRowBase(this)
  }

  get contact_id() {
    return this.origin.contact_id
  }

  get fullName() {
    return this.origin.contact_name
  }

  get formattedNumber() {
    return this.origin.contact_phone
  }

  get comment() {
    return this.origin.feedback_text
  }

  get score() {
    return this.origin.nps_score
  }

  get sent_at() {
    return this.origin.sent_at
  }

  get color() {
    return getUserAvatarColor(this.origin.contact_id)
  }

  get avatarInfo(): IAvatarInfo {
    const isPhoneAbbr = !this.origin.contact_name

    return {
      isPhoneAbbr,
      firstName: this.origin.contact_name || '',
      image: '',
      color: this.color,
      number: this.formattedNumber || '',
    }
  }
}
